module.exports = __webpack_public_path__ + "img/4terGeburtstag.638f870c.svg";